/**
 * Created by Mike Naughton on 6/28/17.
 *
 * A little package for retrieving authentication cookie data.
 */

import base64 from "base-64";
import jwtDecode from "jwt-decode";
import Cookies from "js-cookie";
import URL from "url-js";
import { Auth0Client } from "@auth0/auth0-spa-js";

var currentUrl = new URL(window.location.href);

Cookies.defaults = {
  secure: currentUrl.protocol == "https:",
  // remove the first subdomain from url. ie auth.staging.hbkapps.com -> staging.hbkapps.com
  // this way the domain for the cookie will always be set up one level (ie on staging.hbkapps.com)
  domain: currentUrl.host.split(".").splice(1).join("."),
};

function tokenExpiryDate(token) {
  if (token) {
    var decodedJwt = jwtDecode(token);

    return new Date(decodedJwt.exp * 1000);
  } else {
    return new Date(); //expires now if null
  }
}

function toSetenceCase(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export default {
  client: null,
  token: null,

  createClient: async function (config) {
    this.client = new Auth0Client({
      domain: config.domain,
      client_id: config.client_id,
      audience: config.audience,
      cacheLocation: "localstorage",
    });

    return this.client;
  },

  handleRedirect: async function (client) {
    // Not all browsers support this, please program defensively!
    const params = new URLSearchParams(window.location.search);
    if (params.has("error")) {
      const error = toSetenceCase(params.get("error"));
      const errorDescription = toSetenceCase(params.get("error_description"));

      alert(`${error}: ${errorDescription}`);
    }
    // if code then login success
    if (params.has("code")) {
      // Let the Auth0 SDK do it's stuff - save some state, etc.
      await this.client.handleRedirectCallback();
      // Can be smart here and redirect to original path instead of root
      window.history.replaceState({}, document.title, "/");
    }

    await this.setToken();
  },

  login: async function () {
    // remove the old cookie
    Cookies.remove("X-HBK-User");

    await this.client.loginWithRedirect({
      redirect_uri: window.location.origin,
      prompt: "login",
    });
  },

  logout: async function () {
    return this.client.logout({
      returnTo: "https://auth.hbkapps.com",
    });
  },

  isAuthenticated: async function (client) {
    return await this.client.isAuthenticated();
  },

  /**
   * Updates authentication information.
   * @param data The refreshed data.
   */
  updateData: function (data) {
    // cookies need to be set relative to the parent domain of the current site
    // so, start trying to figure out how we should auth based on stage
    // in order to do this we look at the host from the redirectUrl, the referer, and the current location to determine
    // in we are in localhost, staging, or production (ie, where we came from)
    var returnUrl = new URL(document.referrer || window.location.href);
    // then we set some cookie options based on that url
    var cookieOptions = {
      secure: returnUrl.protocol == "https:",
      // remove the first subdomain from url. ie auth.staging.hbkapps.com -> staging.hbkapps.com
      // this way the domain for the cookie will always be set up one level (ie on staging.hbkapps.com)
      domain: returnUrl.host.split(".").splice(1).join("."),
    };

    Cookies.set(
      "X-HBK-User",
      base64.encode(JSON.stringify(data)),
      cookieOptions
    );
  },

  getToken: async function () {
    if (!this.token) {
      return await this.setToken();
    }

    if (this.token && this.expired()) {
      return await this.setToken();
    }

    return this.token;
  },

  setToken: async function () {
    try {
      let token = await this.client.getTokenSilently();

      this.token = token;
    } catch (e) {
      if (e.message == "Login required") return await this.login();

      console.log(e);
    }

    return this.token;
  },

  expiration: async function () {
    return tokenExpiryDate(this.getToken());
  },

  expired: function () {
    return tokenExpiryDate(this.token) <= Date.now();
  },
};



//////////////////
// WEBPACK FOOTER
// ./public/js/app/auth.js
// module id = 25
// module chunks = 1